export const API_CONFIG = {
  TMDB_API_KEY: '8265bd1679663a7ea12ac168da84d2e8',
  TMDB_BASE_URL: 'https://api.themoviedb.org/3',
  IMAGE_BASE_URL: 'https://image.tmdb.org/t/p'
};

export const IMAGE_SIZES = {
  SMALL: 'w300',
  MEDIUM: 'w500',
  LARGE: 'w780',
  ORIGINAL: 'original'
};
